import styled from 'styled-components';

import { InfoFilledIcon } from '@genially/icons';

import type { Color } from '../../../style/types/theme';
import { Variant } from '../../Tooltip/types';

const getColor = (color: Color, variant = Variant.DARK) => {
  if (variant === Variant.LIGHT) {
    return color.content.reversed.default();
  }

  return color.content.tertiary.default();
};

interface StyledInfoFilledIconProps {
  $variant?: Variant;
}

export const StyledInfoFilledIcon = styled(InfoFilledIcon)<StyledInfoFilledIconProps>(
  ({ theme: { color, size }, $variant }) => ({
    fontSize: size.units(2),
    color: getColor(color, $variant),
    cursor: 'help',
  }),
);
